import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { drawHeader } from "../../../component/WGRHeader";
import { drawFooter } from "../../../component/WGRFooter";
import { drawShopTable } from "./dsaPDFTable";
import { handlePdf, PDF_ACTION } from "../../../../../utils/pdfHelper"
import { drawGrandTotal } from "./dsadrawGrandTotalpdf";
export default function generateWGRPDF(
  reportType,
  title,
  grandTotal,
  rows,
  summary,
  month,
  year
) {
  const doc = new jsPDF({
    orientation: "p",
    unit: "mm",
    format: "a4",
  });

  const grouped = groupByShop(rows);

  let firstPage = true;



  drawHeader(doc, month, year, title);

  Object.keys(grouped)
    .sort((a, b) => Number(a) - Number(b))
    .forEach((shop) => {
      drawShopTable(doc, shop, grouped[shop].rows, grouped[shop].total);
    });



drawGrandTotal(doc, grandTotal);
  

  drawFooter(doc, month, year, title);

  handlePdf(doc, PDF_ACTION.VIEW);
}


function groupByShop(rows) {
  return rows.reduce((groups, row) => {
    const shop = row.DEPOT ?? "Unknown";

    if (!groups[shop]) {
      groups[shop] = {
        rows: [],
        total: {
          debit: 0,
          credit: 0,
          
        },
      };
    }

    groups[shop].rows.push(row);

    groups[shop].total.debit += Number(row.DEBIT || 0);
    groups[shop].total.credit += Number(row.CREDIT || 0);
    

    return groups;
  }, {});
}